import '../vendor/imageMapResizer'
import SLIDER from '../class/slider'
import lity from '../../node_modules/lity/dist/lity';

const [ w, d ] = [ window, document ];

const gallerySlider = new SLIDER({
  obj: '[data-plugin="slider"]',
  slickOpt: {
    autoplay: true,
    centerMode: true,
    variableWidth: true,
    fade: false,
    dots: false,
    speed: 7500,
    easing: 'linear',
    cssEase: 'linear',
    autoplaySpeed: 0,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    draggable: false
  }
});

const init = () => {

  $.when( w.load['header'] ).then( () => {
    let url = '/corporate/';

    switch( parseInt( w.query_string('article') ) ){
      case 5: case 6: case 7: case 8: case 9:
        url += '?mode=detail&article=5'; break
    }
    $('.p-gnav__list').currentMenu({mode: 0, url });
  });

  if( w.load['loadHtml']) {
    w.load['loadHtml'].then( () => {
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      if ( gallerySlider ) {
        gallerySlider.init(), gallerySlider.start();
        //スマホでタップ時にautoplayが止まる現象の対策
        $('.corporate-slider').on('touchend', () => gallerySlider.start());
      }

    });
  }

  $.when( w.load['corporate04'] ).then(() => {
    //イメージマップ レスポンシブ化
    imageMapResize();

    //モーダル
    $('[data-lity-link]').each( (i,obj) => {
      $(obj).on('click', () => {
        const lityInstance = lity(obj.getAttribute('href'));
        const $lityElement = lityInstance.element();

        //モーダル内スライダー
        const modalSlider = new SLIDER({
          obj: $lityElement.find('[data-plugin="slider"]'),
          slickOpt: {
            autoplay: false,
            fade: false,
            dots: false,
            speed: 1500,
            autoplaySpeed: 0,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow" type="button" style="display: block;"><svg class="icon" width="20" height="43"><use href="/asset/svg/sprite.symbol.svg#arrow-angle-left"></use></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow" type="button" style="display: block;"><svg class="icon" width="20" height="43"><use href="/asset/svg/sprite.symbol.svg#arrow-angle-right"></use></svg></button>',
          }
        });
        modalSlider.init();

        //モーダルを閉じたらslickを解除
        $(d).on('lity:close', () => {
          setTimeout( () => $('[data-plugin="slider"].slick-initialized').slick('unslick'), 200);
        } );
        return false
      });
    });


  });

}

export default function CORPORATE() {
  $( init )
}